import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import Black from '../views/layout/black'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home', affix: true, keepAlive: true}
    }]
  },
  // 甘特图测试页面
  /*{
    path: '',
    component: Layout,
    redirect: '/gantt',
    children: [{
      path: 'gantt',
      name: 'gantt',
      component: () => import('@/views/home/ganttTest'),
      meta: {title: '甘特图', icon: 'home', affix: true, keepAlive: true}
    }]
  },*/
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
]

export const asyncRouterMap = [
  {
    path: '/map',
    name: 'map',
    component: Layout,
    redirect: '/index',
    meta: {title: '地图', icon: 'land'},
    children: [{
      path: 'index',
      name: 'map',
      // component: () => import('@/views/map/index'),
      meta: {title: '地图', icon: 'land', affix: true, keepAlive: true,sysModel: true}
    }]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin', keepAlive: true}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'office',
        name: 'office',
        component: () => import('@/views/ums/office/index'),
        meta: {title: '机构列表', icon: 'ums-menu'}
      },
      {
        path: 'addOffice',
        name: 'addOffice',
        component: () => import('@/views/ums/office/add'),
        meta: {title: '添加机构'},
        hidden: true
      },
      {
        path: 'updateOffice',
        name: 'updateOffice',
        component: () => import('@/views/ums/office/update'),
        meta: {title: '修改机构'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path:'/promptInformation',
    component: Layout,
    redirect: '/promptInformation/',
    name: 'promptInformation',
    meta: {title: 'promptInformation', icon: 'message'},
    children: [
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/notice/index'),
        meta: {title: '提示信息'}
      }
    ]
  },
  {
    path:'/propertyInformation',
    component: Layout,
    redirect: '/propertyInformation/',
    name: 'propertyInformation',
    meta: {title: '产权资料', icon: 'ums-resource'},
    children: [
      {
        path: 'propertyRightMaterial',
        name: 'propertyRightMaterial',
        component: () => import('@/views/propertyRightMaterial/index'),
        meta: {title: '产权资料'}
      }
    ]
  },
  {
    path:'/parcelProject',
    component: Layout,
    name: 'parcelProject',
    redirect: '/parcelProject',
    meta: {title: '宗地立项', icon: 'ums-resource'},
    children: [
      {
        path: 'standardland',
        name: 'standardland',
        component: () => import('@/views/standardland/index'),
        meta: {title: '宗地立项'}
      }
    ]
  },
  {
    path:'/assesstask',
    component: Layout,
    redirect: '/assesstask/',
    name: 'assesstask',
    meta: {title: '评估作业', icon: 'ums-resource'},
    children:[
      {
        path: 'calibrationInfo',
        name: 'calibrationInfo',
        component: () => import('@/views/assesstask/calibrationInfo'),
        meta: {title:'评估测算', icon: 'ums-resource'},
        hidden:false
      },
      {
        path:'/xxhs',
        component: Black,
        name: 'xxhs',
        meta: {title: '信息核实', icon: 'ums'},
        children: [
          /*{
            path: 'confirmInfo/baseLandInfo',
            name: 'confirmInfo',
            component: () => import('@/views/assesstask/baseLandInfo'),
            meta: {title:'基本信息登记表', icon: 'base-information'},
            hidden:false
          },*/
          {
            path: 'technologyPoints',
            name: 'technologyPoints',
            component: () => import('@/views/assesstask/technologyPoints'),
            meta: {title:'技术要点表', icon: 'technical-points'},
            hidden:false
          }
        ]
      },
	  {
        path:'/qtxxsc',
        component: Black,
        redirect: '/assesstask/confirmInfo/baseLandInfo',
        name: 'qtxxsc',
        meta: {title: '其他信息上传', icon: 'ums'},
        children: [
          {
            path: 'otherAttrs/siteSurverInfo',
            name: 'otherAttrs',
            component: () => import('@/views/assesstask/siteSurveyInfo'),
            meta: {title:'现场勘查信息', icon: 'survey'},
            hidden:false
		      },
          {
            path: 'otherAttrs/reportScanFile',
            name: 'reportScanFile',
            component: () => import('@/views/assesstask/reportScanFile'),
            meta: {title:'报告签字页扫描件', icon: 'sign'},
            hidden:false
          },
          {
            path: 'wordReport',
            name: 'wordReport',
            component: () => import('@/views/assesstask/wordReport'),
            meta: {title:'报告汇总', icon: 'report-summary'},
            hidden:false
          },
          {
            path: 'otherAttrs/simpleReportScan',
            name: 'simpleReportScan',
            component: () => import('@/views/simpleReportScan'),
            meta: {title:'简版报告扫描件', icon: 'sign'},
            hidden:false
          }
        ]
      },
      {
        path: 'paramContrast',
        name: 'paramContrast',
        component: () => import('@/views/assesstask/paramContrast'),
        meta: {title:'参数审核'},
        hidden:false
      },
      {
        path: 'shortReportConfirm',
        name: 'shortReportConfirm',
        component: () => import('@/views/assesstask/shortReportConfirm'),
        meta: {title:'简版报告汇总'},
        hidden:false
      },{
        path: 'wordReport1',
        name: 'wordReport1',
        component: () => import('@/views/assesstask/wordReport'),
        meta: {title:'报告汇总', icon: 'report-summary'},
        hidden:false
      },
      {
        path: 'siteSurverInfo1',
        name: 'siteSurverInfo1',
        component: () => import('@/views/assesstask/siteSurveyInfo'),
        meta: {title:'现场勘查信息', icon: 'survey'},
        hidden:false
      }
    ]
  },
  {
    path:'/reportFiles',
    component: Layout,
    name: 'reportFiles',
    meta: {title: '报告素材', icon: 'ums-resource'},
    children: [
      {
        path: '/appraiser',
        name: 'appraiser',
        component: Black,
        meta: {title:'估价师列表',icon: 'base-information'},
        children: [
          {
            path: 'valuer',
            name: 'valuer',
            component: () => import('@/views/reportMaterial/appraiser'),
            meta: {title:'估价师名单', icon: 'base-information'},
            hidden:false
          }
        ]
      },
      {
        path: '/layoutSituation',
        name: 'layoutSituation',
        component: Black,
        meta: {title:'布设情况',icon: 'base-information'},
        children: [
          {
            path: 'landLayoutSituation',
            name: 'landLayoutSituation',
            component: () => import('@/views/reportMaterial/landLayoutSituation'),
            meta: {title:'宗地布设情况', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landLayoutUpdateInfo',
            name: 'landLayoutUpdateInfo',
            component: () => import('@/views/reportMaterial/landLayoutUpdateInfo'),
            meta: {title:'宗地更新情况', icon: 'base-information'},
            hidden:false
          },
        ]
      },
      /*{
        path: '/connotationAndMethodStatistics',
        name: 'connotationAndMethodStatistics',
        component: Black,
        meta: {title:'地价内涵表、方法统计',icon: 'base-information'},
        children: [
          {
            path: 'methodStatistics',
            name: 'methodStatistics',
            component: () => import('@/views/reportMaterial/methodStatistics'),
            meta: {title:'方法统计', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landPriceConnTable',
            name: 'landPriceConnTable',
            component: () => import('@/views/reportMaterial/landPriceConnTable'),
            meta: {title:'地价内涵表', icon: 'base-information'},
            hidden:false
          }
        ]
      },*/
      {
        path: 'methodStatistics',
        name: 'methodStatistics',
        component: () => import('@/views/reportMaterial/methodStatistics'),
        meta: {title:'方法统计', icon: 'base-information'},
        hidden:false
      },
      {
        path: 'landPriceConnTable',
        name: 'landPriceConnTable',
        component: () => import('@/views/reportMaterial/landPriceConnTable'),
        meta: {title:'地价内涵表', icon: 'base-information'},
        hidden:false
      },
      {
        path: '/landLayoutReductionRateInfo',
        name: 'landLayoutReductionRateInfo',
        component: Black,
        meta: {title:'还原率信息',icon: 'base-information'},
        children: [
          {
            path: 'landLayoutReductionRate',
            name: 'landLayoutReductionRate',
            component: () => import('@/views/reportMaterial/landLayoutReductionRate'),
            meta: {title:'还原率确定', icon: 'base-information'},
            hidden:false
          }
        ]
      },
      {
        path: 'regionalFactorCorrection',
        name: 'regionalFactorCorrection',
        component: () => import('@/views/reportMaterial/regionalFactorCorrection'),
        meta: {title:'区域因素修正', icon: 'base-information'},
        hidden:false
      },
      {
        path: '/landPriceAnalysis',
        name: 'landPriceAnalysis',
        component: Black,
        meta: {title:'地价分析',icon: 'base-information'},
        children: [
          {
            path: 'overallLandPriceLevelStatus',
            name: 'overallLandPriceLevelStatus',
            component: () => import('@/views/reportMaterial/overallLandPriceLevelStatus'),
            meta: {title:'总体地价水平状况表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'priceContrast',
            name: 'priceContrast',
            component: () => import('@/views/reportMaterial/priceContrast'),
            meta: {title:'价格对比表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landLayoutNoUpdateInfo',
            name: 'landLayoutNoUpdateInfo',
            component: () => import('@/views/reportMaterial/landLayoutNoUpdateInfo'),
            meta: {title:'标准宗地无发生更换情况表', icon: 'base-information'},
            hidden:false
          }
        ]
      }
    ]
  },
  {
    path:'/result',
    component: Layout,
    redirect: '/result',
    name: 'result',
    meta: {title: '成果生成', icon: 'ums-resource'},
    children:[
      {
        path: 'landResult',
        name: 'landResult',
        component: () => import('@/views/result/landResult'),
        meta: {title:'宗地成果'},
        hidden:false
      },{
        path: 'publicInfoResult',
        name: 'publicInfoResult',
        component: () => import('@/views/result/publicInfoResult'),
        meta: {title:'公示信息'},
        hidden:false
      },{
        path: 'baseLandInfo1',
        name: 'baseLandInfo1',
        component: () => import('@/views/assesstask/baseLandInfo'),
        meta: {title:'基本信息登记表', icon: 'base-information'},
        hidden:false
      },{
        path: 'technologyPoints1',
        name: 'technologyPoints1',
        component: () => import('@/views/assesstask/technologyPoints'),
        meta: {title:'技术要点表', icon: 'technical-points'},
        hidden:false
      },{
        path: 'adviseResult',
        name: 'adviseResult',
        component: () => import('@/views/result/adviseResult'),
        meta: {title:'建议及结果表'},
        hidden:false
      },{
        path: 'reportScanFile1',
        name: 'reportScanFile1',
        component: () => import('@/views/assesstask/reportScanFile'),
        meta: {title:'报告签字页扫描件', icon: 'sign'},
        hidden:false
      },{
        path: 'simpleReportScan1',
        name: 'simpleReportScan1',
        component: () => import('@/views/simpleReportScan'),
        meta: {title:'简版报告扫描件', icon: 'sign'},
        hidden:false
      }
    ]
  },
  {
    path:'/tempFileManager',
    component: Layout,
    redirect: '/tempFileManager/',
    name: 'tempFileManager',
    meta: {title: '模版管理', icon: 'ums-resource'},
    children:[
      {
        path:'/pgzy',
        component: Black,
        name: 'pgzy',
        meta: {title: '评估作业', icon: 'ums'},
        children:[
          {
            path: 'calculationExcel',
            name: 'calculationExcel',
            component: () => import('@/views/tempFile/calculationExcel'),
            meta: {title:'测算表模板(新)', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'lastVerionCalculationExcel',
            name: 'lastVerionCalculationExcel',
            component: () => import('@/views/tempFile/oldCalculationExcel'),
            meta: {title:'测算表模板(旧)', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'paramComparExcel',
            name: 'paramComparExcel',
            component: () => import('@/views/tempFile/paramCompar'),
            meta: {title:'参数对比表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'shortReportExcel',
            name: 'shortReportExcel',
            component: () => import('@/views/tempFile/shortReport/index'),
            meta: {title:'简版报告汇总表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'siteSurveyExcel',
            name: 'siteSurveyExcel',
            component: () => import('@/views/tempFile/siteSurvey'),
            meta: {title:'现场勘查表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'priceRecordExcel',
            name: 'priceRecordExcel',
            component: () => import('@/views/tempFile/priceRecord'),
            meta: {title:'价格调整记录表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'batchReplaceTemp',
            name: 'batchReplaceTemp',
            component: () => import('@/views/tempFile/batchReplaceTemp'),
            meta: {title:'批量替换公式/值表', icon: 'base-information'},
            hidden:false
          }
        ]
      },
      {
        path:'/reportTemp',
        component: Black,
        name: 'reportTemp',
        meta: {title: '数据统计分析', icon: 'ums'},
        children: [
          {
            path: 'appraiserExcel',
            name: 'appraiserExcel',
            component: () => import('@/views/tempFile/reportMaterial/appraiser/excel'),
            meta: {title:'估价师名单表格', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'appraiserWord',
            name: 'appraiserWord',
            component: () => import('@/views/tempFile/reportMaterial/appraiser/word'),
            meta: {title:'估价师名单报告', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'excel',
            name: 'excel',
            component: () => import('@/views/tempFile/reportMaterial/landLayoutSituation/excel'),
            meta: {title:'布设情况表格', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'word',
            name: 'word',
            component: () => import('@/views/tempFile/reportMaterial/landLayoutSituation/word'),
            meta: {title:'布设情况报告', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landLayoutUpdateExcel',
            name: 'landLayoutUpdateExcel',
            component: () => import('@/views/tempFile/reportMaterial/landLayoutUpdateInfo/excel'),
            meta: {title:'宗地更新情况表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landLayoutUpdateWord',
            name: 'landLayoutUpdateWord',
            component: () => import('@/views/tempFile/reportMaterial/landLayoutUpdateInfo/word'),
            meta: {title:'宗地更新报告', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landLayoutUpdateHisExcel',
            name: 'landLayoutUpdateHisExcel',
            component: () => import('@/views/tempFile/reportMaterial/landLayoutUpdateInfo/hisDataExcel'),
            meta: {title:'宗地更新历史表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landPriceConnTableExcel',
            name: 'landPriceConnTableExcel',
            component: () => import('@/views/tempFile/reportMaterial/landPriceConnTable/excel'),
            meta: {title:'地价内涵表表格', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landPriceConnTableWord',
            name: 'landPriceConnTableWord',
            component: () => import('@/views/tempFile/reportMaterial/landPriceConnTable/word'),
            meta: {title:'地价内涵表报告', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'methodStatistics',
            name: 'methodStatistics',
            component: () => import('@/views/tempFile/reportMaterial/methodStatistics'),
            meta: {title:'方法统计报告', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landLayoutReductionRate',
            name: 'landLayoutReductionRate',
            component: () => import('@/views/tempFile/reportMaterial/landLayoutReductionRate/word'),
            meta: {title:'还原率确定报告', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'deteOfCompReduExcel',
            name: 'deteOfCompReduExcel',
            component: () => import('@/views/tempFile/reportMaterial/deteOfCompRedu/excel'),
            meta: {title:'各用途还原率表格', icon: 'base-information'},
            hidden:false
          },
        /*  {
            path: 'deteOfCompReduWord1',
            name: 'deteOfCompReduWord1',
            component: () => import('@/views/tempFile/reportMaterial/deteOfCompRedu/word/wordIndex1'),
            meta: {title:'各用途还原率报告1', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'deteOfCompReduWord2',
            name: 'deteOfCompReduWord2',
            component: () => import('@/views/tempFile/reportMaterial/deteOfCompRedu/word/wordIndex2'),
            meta: {title:'各用途还原率报告2', icon: 'base-information'},
            hidden:false
          },*/
          {
            path: 'regionalFactorCorrectionWord',
            name: 'regionalFactorCorrectionWord',
            component: () => import('@/views/tempFile/reportMaterial/regionalFactorCorrection/word'),
            meta: {title:'区域因素修正', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'regionalFactorCorrectionExcel',
            name: 'regionalFactorCorrectionExcel',
            component: () => import('@/views/tempFile/reportMaterial/regionalFactorCorrection/excel'),
            meta: {title:'区域因素修正表格示例', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'overallLandPriceLevelStatusExcel',
            name: 'overallLandPriceLevelStatusExcel',
            component: () => import('@/views/tempFile/reportMaterial/overallLandPriceLevelStatus/excel'),
            meta: {title:'总体地价表格', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'overallLandPriceLevelStatusWord',
            name: 'overallLandPriceLevelStatusWord',
            component: () => import('@/views/tempFile/reportMaterial/overallLandPriceLevelStatus/word'),
            meta: {title:'总体地价报告表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'priceContrastExcel',
            name: 'priceContrastExcel',
            component: () => import('@/views/tempFile/reportMaterial/priceContrast/excel'),
            meta: {title:'价格对比表格', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'priceContrastWord',
            name: 'priceContrastWord',
            component: () => import('@/views/tempFile/reportMaterial/priceContrast/word'),
            meta: {title:'价格对比报告', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landLayoutNoUpdateInfoExcel',
            name: 'landLayoutNoUpdateInfoExcel',
            component: () => import('@/views/tempFile/reportMaterial/landLayoutNoUpdateInfo/excel'),
            meta: {title:'标准宗地无更换表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landLayoutNoUpdateInfoWord',
            name: 'landLayoutNoUpdateInfoWord',
            component: () => import('@/views/tempFile/reportMaterial/landLayoutNoUpdateInfo/word'),
            meta: {title:'标准宗地无更换报告', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'useTypeExample',
            name: 'useTypeExample',
            component: () => import('@/views/tempFile/reportMaterial/useTypeExcelExample'),
            meta: {title:'用途还原率示例', icon: 'base-information'},
            hidden:false
          },
        ]
      },
      {
        path:'/cgsc',
        component: Black,
        name: 'cgsc',
        meta: {title: '成果素材', icon: 'ums'},
        children:[
          {
            path: 'suggResultsExcel',
            name: 'suggResultsExcel',
            component: () => import('@/views/tempFile/suggResults'),
            meta: {title:'建议及结果表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'puliceInfoExcel',
            name: 'puliceInfoExcel',
            component: () => import('@/views/tempFile/puliceInfo'),
            meta: {title:'公示信息表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landPublicSituationExcel',
            name: 'landPublicSituationExcel',
            component: () => import('@/views/tempFile/landPublicSituation'),
            meta: {title:'宗地公示情况表', icon: 'base-information'},
            hidden:false
          },
         /* {
            path: 'landBaseExcel',
            name: 'landBaseExcel',
            component: () => import('@/views/tempFile/landbase'),
            meta: {title:'宗地基本信息表', icon: 'base-information'},
            hidden:false
          },*/
          {
            path: 'landBaseCollectExcel',
            name: 'landBaseCollectExcel',
            component: () => import('@/views/tempFile/landBaseCollect'),
            meta: {title:'宗地基本信息汇总表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'landPriceDiffExcel',
            name: 'landPriceDiffExcel',
            component: () => import('@/views/tempFile/landPriceDiffExcel'),
            meta: {title:'标准宗地价格差异率', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'technicalPointsExcel',
            name: 'technicalPointsExcel',
            component: () => import('@/views/tempFile/technicalPoints'),
            meta: {title:'技术要点表', icon: 'base-information'},
            hidden:false
          },
        ]
      },
      {
        path:'/qtgl',
        component: Black,
        name: 'qtgl',
        meta: {title: '其他管理', icon: 'ums'},
        children:[
          {
            path: 'standardlandExcel',
            name: 'standardlandExcel',
            component: () => import('@/views/tempFile/standardland'),
            meta: {title:'估价师分配表', icon: 'base-information'},
            hidden:false
          },
          {
            path: 'reportConfig',
            name: 'reportConfig',
            component: () => import('@/views/tempFile/reportConfig'),
            meta: {title:'结果报告配置', icon: 'order-setting'},
            hidden:false
          },
          {
            path: 'homePageDataExcel',
            name: 'homePageDataExcel',
            component: () => import('@/views/tempFile/homePageData'),
            meta: {title:'首页信息模板表', icon: 'base-information'},
            hidden:false
          }
        ]
      },
    ]
  },
  {
    path:'/dataSource',
    component: Layout,
    redirect: '/dataSource',
    name: 'dataSource',
    meta: {title: '原始数据', icon: 'ums-resource'},
    children:[
      {
        path: 'landPublicSituation',
        name: 'landPublicSituation',
        component: () => import('@/views/dataSource/landPublicSituation'),
        meta: {title:'宗地公示情况表'},
        hidden:false
      },
      {
        path: 'landBookbuilding',
        name: 'landBookbuilding',
        component: () => import('@/views/dataSource/landBookbuilding'),
        meta: {title:'宗地档案'},
        hidden:false
      },
      {
        path: 'calculateTable',
        name: 'calculateTable',
        component: () => import('@/views/dataSource/calculateTable'),
        meta: {title:'测算表'},
        hidden:false
      },
      {
        path: 'finalPublicityInfo',
        name: 'finalPublicityInfo',
        component: () => import('@/views/dataSource/finalPublicityInfo'),
        meta: {title:'公示信息表'},
        hidden:false
      },
    ]
  },
  {
    path:'/sysConfig',
    component: Layout,
    redirect: '/sysConfig/',
    name: 'sysConfig',
    meta: {title: '系统配置', icon: 'ums-resource'},
    children:[
      {
        path: 'sysDict',
        name: 'sysDict',
        component: () => import('@/views/sys/sysDict'),
        meta: {title:'数据字典'},
        hidden:false
      },{
        path: 'helpCenter',
        name: 'helpCenter',
        component: () => import('@/views/sys/helpCenter'),
        meta: {title:'帮助设置'},
        hidden:false
      },
      {
        path: 'updateHelpCenter',
        name: 'updateHelpCenter',
        component: () => import('@/views/sys/helpCenter/update'),
        meta: {title: '编辑帮助', icon: 'ums-menu'},
        hidden:true
      },
      {
        path: 'addHelpCenter',
        name: 'addHelpCenter',
        component: () => import('@/views/sys/helpCenter/add'),
        meta: {title: '添加帮助'},
        hidden: true
      },
      {
        path: 'wcSynch',
        name: 'wcSynch',
        component: () => import('@/views/wcSynch/index'),
        meta: {title:'外采估价师绑定', icon: 'base-information'},
        hidden:false
      },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/config/index'),
        meta: {title: '配置管理', icon: 'ums-menu'},
        hidden:false
      },
      {
        path: 'addConfig',
        name: 'addConfig',
        component: () => import('@/views/config/add'),
        meta: {title: '添加配置'},
        hidden: true
      },
      {
        path: 'updateConfig',
        name: 'updateConfig',
        component: () => import('@/views/config/update'),
        meta: {title: '修改配置'},
        hidden: true
      },
      {
        path: 'operationManual',
        name: 'operationManual',
        component: () => import('@/views/operationManual'),
        meta: {title:'操作手册'},
        hidden:false
      },
      {
        path: 'calculationTableConfig',
        name: 'calculationTableConfig',
        component: () => import('@/views/tableHeaderConfig/calculationTable'),
        meta: {title:'评估测算表头配置', icon: 'order-setting'},
        hidden:false
      },
      {
        path: 'headerAuthority',
        name: 'headerAuthority',
        component: () => import('@/views/headerAuthority/index'),
        meta: {title:'表头权限配置', icon: 'order-setting'},
        hidden:false
      },
      {
        path: 'gisConfig',
        name: 'gisConfig',
        component: () => import('@/views/gisConfig/index'),
        meta: {title: '图层配置管理', icon: 'ums-menu'},
        hidden:false
      },
      {
        path: 'addGisConfig',
        name: 'addGisConfig',
        component: () => import('@/views/gisConfig/add'),
        meta: {title: '添加配置'},
        hidden: true
      },
      {
        path: 'updateGisConfig',
        name: 'updateGisConfig',
        component: () => import('@/views/gisConfig/update'),
        meta: {title: '修改配置'},
        hidden: true
      },
      {
        path: 'pepHomeUrl',
        name: 'pepHomeUrl',
        component: () => import('@/views/sys/pep'),
        meta: {title: '评E评后台', icon: 'ums-menu'},
        hidden:false
      },
      {
        path: 'updateExcelVersion',
        name: 'updateExcelVersion',
        component: () => import('@/views/sys/updateVersion'),
        meta: {title: '测算表更新配置', icon: 'ums-menu'},
        hidden:false
      },
    ]
  },
  {
      path:'/help',
      component: Layout,
      redirect: '/helpPage',
      name: 'helpPage',
      meta: {title: '帮助中心', icon: 'ums-resource'},
      children: [{
        path:'helpPage',
        name: 'helpPage',
        component: () => import('@/views/sys/help/index'),
         meta: {title: '帮助中心', icon: 'ums-resource'}
      }]
    },
  {
    path:'/updateOnline',
    component: Layout,
    name: 'updateOnline',
    redirect: '/updateOnline',
    meta: {title: '在线更新测算表', icon: 'ums-resource'},
    children: [
      {
        path: 'updateOnline',
        name: 'updateOnline',
        component: () => import('@/views/updateVerionOnline/index'),
        meta: {title: '在线更新测算表'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js